import axios from 'axios';

const HTTPClient = axios.create({
    withCredentials: true,
    headers: {"Content-Type": "application/json"}
});

export default HTTPClient;